import React from "react";
import "./styles/AuthLoader.css";

const AuthLoader = () => {
  return <div class="auth-loader"></div>;
};

export default AuthLoader;
